import Transformer from './Transformer';

class UserTransformer extends Transformer {
  static transform(user) {
    const newUser = { ...user };
    if (user && user.groups) {
      newUser.groups = getSortedGroups(newUser.groups);
      newUser.groupKeys = user.groups.map((group) => group.key);
    }
    if (user && user.tags) {
      newUser.tags = getSortedTags(newUser.tags);
      newUser.tagKeys = user.tags.map((tag) => tag.key);
    }
    return newUser;
  }

  static transformForApi(user) {
    const newUser = this.snakeCaseKeysDeep(user);
    if (newUser.sms_phone_number) {
      newUser.sms_phone_number = newUser.sms_phone_number.replace(/\(|\)|-| /gi, '');
    }
    return newUser;
  }
}

export default UserTransformer;

function getSortedGroups(groups) {
  return [...groups].sort((a, b) => {
    if (a.name.toLowerCase() > b.name.toLowerCase()) {
      return 1;
    }
    return -1;
  });
}

function getSortedTags(tags) {
  return [...tags].sort((a, b) => {
    if (a.value.toLowerCase() > b.value.toLowerCase()) {
      return 1;
    }
    return -1;
  });
}
